<template>
	<div>
	<!-- DIALOGS -->
	<LabelSalesDataGemaTas2026Dialog />
	<SelectionRequiredDialog /> 
	<DeletionDialog context="SelectedSalesData" />	
	<RunErrorListDialog :context="context" />
	<InlineEditingListpageDialog :listPageContext="context" />
	<MoveIntoCompanyDialog 
                :context="'LabelSalesData'"
                :message="$t('lang_LABEL_SALESDATA_DIALOG_CAPTION_MOVE_SALESDATA')"
            />
	<FileImportDialog 
		:context="context"
		:alvqaContext="alvqa +'-list'"
	>
		<template v-slot:importOptions>
          <div align="center">
            <BasePeriod 
                context="ImportDialog"
                periodLabel="lang_GENERAL_CAPTION_UPLOADER_PERIOD_OPTIONAL"
                widthTimeUnitField="4"
                :undefinedTimeUnit="true"
                justify="center"
            />
          </div>

          <v-row v-if="withAbbreviation">
                <v-col>
                    <!-- Context = PublishingIncome -->
                    <BaseEditPageDropdown 
                        field="Abbreviation"
                        :label="$t('lang_GENERIC_CAPTION_ABBREVIATION')"
                        :items="abbreviationsOptions"
                        :context="context"
                        :withMargin="false"
                        :clearable="true"
                        :alvqa="alvqa + '-dropdown-abbreviation'"
                    />
                </v-col>
            </v-row>
			<v-row>
				<v-col class="pb-1">
					<span class="black-label">
						<v-checkbox 
							v-model="selectedImportCheckboxes"
							value="runErrorLists"
							hide-details 
							color="generalCheckbox"  
							class="mt-0"
							:alvqa="alvqa + '-list-file-import-dialog-checkbox-run-error-lists'"
						>
							<template v-slot:label>
								<span 
									class="black--text"
									:alvqa="alvqa + '-list-file-import-dialog-checkbox-run-error-lists'"
								>{{ $t('lang_GENERAL_CAPTION_UPLOADER_RUN_ERROR_LISTS') }}</span>
							</template>
						</v-checkbox>
					</span>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="5">
					<BaseEditPageTextField
						:context="context"
						field="ImportCommissionPercent"
						:label="$t('lang_PUBLISHING_INCOME_CAPTION_COMMISSION_PERCENT')"
						:withMargin="false"
						rules='percent3Decimals'
						:alvqa="alvqa + '-textfield-commission-percent'"
					/>
				</v-col>

				<v-col class="pb-0" cols="7">
					<BaseEditPageTextField
						:context="context"
						field="ImportCurrencyConversionFactor"
						:label="$t('lang_LABEL_SALES_DATA_IMPORT_DIALOG_CAPTION_CONVERSION_FACTOR')"
						:withMargin="false"
						:alvqa="alvqa + '-list-file-import-dialog-textfield-currency-conversion-factor'"
					/>
				</v-col>
			</v-row>	  				
		</template>	
	</FileImportDialog>		
		<BaseListPage
			headline="lang_LABEL_SALES_DATA"
            :context="context"
            :alvqa="alvqa"
            :stickyHeader="true"
		>
			<template v-slot:filter>
				<v-col cols="2">
					<DropdownFilter
						:context="context + 'HalfYearFilter'"
						label="lang_GENERAL_PERIOD_FILTER_OPTION_HALFYEAR"
						:items="halfYearOptions"
						:defaultValueNull="true"
						:alvqa="alvqa + '-list-dropdown-half-year-filter'"
					/>
				</v-col>
			</template>
		<!-- DATA TABLE COMPONENT -->
			<template v-slot:dataTable>
				<BaseDataTableList 					
					:headers="headers"
					:context="context"
					:alvqa="alvqa"
					:editInlineFunction="inlineEditing"
					:hasServerSideSorting="true"
					:stickyTopSlot="true"
				>
				<!-- TOPSLOT: actions, imports etc. -->
					<template v-slot:topSlot><SalesDataTopslot /></template>

				<!-- DATA TABLE CONTENT: columns -->
					<template v-slot:body="{ item }">
						<ExpandIcon 
							:isExpanded="item.isExpanded" 
							:alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-expand'"
							:color="item.item.errorListExists ? 'standardBrownIcon' : 'buttonStandard'"
          				/>
                        <td class="ellipsis">
							<BaseTooltip>
								<template v-slot:text>{{ item.item.source }} ({{ item.item.sourceAlvId }})</template>
								<template v-slot:content>
									<span :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-source'">
										{{ item.item.source }}
									</span>
								</template>
							</BaseTooltip>
          				</td>
                        <td 
							class="no_ellipsis text-right" 
							:alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-period'"
						>
							{{ $alvPlugin.displayPeriod(item.item.period) }}
						</td>
                        <td 
							class="no_ellipsis text-right" 
							:alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-sum'"
						>
							{{ $alvPlugin.getNumberLocalization(item.item.sum, 'number') }}
						</td>
                        <td 
							class="no_ellipsis text-right" 
							:alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-records'"
						>{{ $alvPlugin.getNumberLocalization(item.item.records, 'numberInteger') }}
                        </td>
          				<td class="ellipsis">
							<BaseTooltip>
								<template v-slot:text>{{ item.item.fileName }}</template>
								<template v-slot:content><span :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-file-name'">{{ item.item.fileName }}</span></template>
							</BaseTooltip>
          				</td>
						<td class="ellipsis">
							<BaseTooltip :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-import-date'">
								<template v-slot:content>{{ $d(new Date(item.item.importDate), 'alvDateTime') }}</template>
								<template v-slot:text>
									{{ item.item.mapping 
									? $t('lang_GENERIC_CAPTION_MAPPING') + ': ' + item.item.mapping.title + 
										' (' + item.item.mapping.alvId + 
										(item.item.mapping.abbreviation ? ', ' + item.item.mapping.abbreviation : '') + ')'
									: (item.item.source === 'multiple' || item.item.source === 'Mehrere' 
										? $t('lang_LABEL_SALESDATA_CAPTION_LEGACY_IMPORTER_TEMPLATE')
										: $t('lang_LABEL_SALESDATA_CAPTION_LEGACY_IMPORTER_SOURCE') + ' ' + item.item.source) }}
								</template>
							</BaseTooltip>
						</td>
						<td class="text-right ellipsis">
							<BaseTooltip 
							:simpleText="$alvPlugin.getNumberLocalization(item.item.conversionFactor, 'decimal8')" 
							:alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-list-ccf'"
							/>
						</td>
						<!-- :simpleText="$alvPlugin.getNumberLocalization(item.item.conversionFactor, 'decimal8')" -->
					</template>
				<!-- EXPAND: Read Only View -->
					<template v-slot:expandSlot="{ id }"><SalesDataReadOnly :itemId='id' /></template>
				</BaseDataTableList>
			</template>
		</BaseListPage>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

import BaseListPage from '@/components/_base/BaseListPage'
import BaseDataTableList from '@/components/_base/BaseDataTableList'
import BaseTooltip from '@/components/_base/BaseTooltip'
import ExpandIcon from '@/components/_buttons/ExpandIcon'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BasePeriod from '@/components/_base/BasePeriod'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import DropdownFilter from '@/components/_filters/DropdownFilter'

import SalesDataTopslot from './SalesDataTopSlot'
import SalesDataReadOnly from './_readonly/SalesDataReadOnly'
import LabelSalesDataGemaTas2026Dialog from './_dialogs/LabelSalesDataGemaTas2026Dialog'

import FileImportDialog from '@/components/_dialogs/FileImportDialog'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import SelectionRequiredDialog from '@/components/_dialogs/SelectionRequiredDialog'
import RunErrorListDialog from '@/components/_dialogs/RunErrorListDialog'
import InlineEditingListpageDialog from '@/components/_dialogs/InlineEditingListpageDialog'
import MoveIntoCompanyDialog from '@/components/_dialogs//MoveIntoCompanyDialog'

export default {
	name: "SalesDataList",
	components: {
		BaseDataTableList,
		BaseListPage,
		BaseTooltip,
		BasePeriod,
		BaseEditPageTextField,
		ExpandIcon,
        BaseEditPageDropdown,
		DropdownFilter,
		
		SalesDataTopslot,
		SalesDataReadOnly,

		FileImportDialog,
        DeletionDialog,
		SelectionRequiredDialog,
		RunErrorListDialog,
		InlineEditingListpageDialog,
		MoveIntoCompanyDialog,
		LabelSalesDataGemaTas2026Dialog,
	},
	data () {
		return {
			context: "SalesData",
			alvqa: "label-sales-data",
		}
	},
	computed: {
        ...mapGetters(['getSalesDataSearch']),
		halfYearOptions() {
			let halfYears = []
			const today = new Date()
			const maxYear = today.getFullYear()
			const currentHalfYear = today.getMonth() < 6 ? 1 : 2
			for(let year = maxYear; year >= 2008; year--) {
				for(let halfYear = year === maxYear ? currentHalfYear : 2; halfYear >= 1; halfYear--) {
					halfYears.push({
						text: this.$alvPlugin.displayPeriod({ num: halfYear, period: 'halfyear', year }),
						value: year + '-' + halfYear,
						alvqa: this.alvqa + '-dropdown-half-year-' + year + '-' + halfYear
					})
				}
			}
			return halfYears
		},
		// Returns an Array with header-objects with props.
	   headers() {
		   return [
				{
					text: '', 
					value: 'data-table-select', 
					align: 'center',
					width: "60px",
					sortable: false,
					class: 'text-no-wrap'
				},
				{
					text: '', 
					value: 'data-table-expand',
					align: 'center', 
					width: "48px",
					sortable: false,
					class: 'text-no-wrap'
				},
                {
                    text: this.$t('lang_GENERIC_CAPTION_SOURCE'), 
                    value: 'source',
                    align: 'left', 
                    sortable: false,
                    width:"200px",
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_PERIOD'), 
                    value: 'period',
                    align: 'end', 
                    sortable: true,
                    width: "150px",
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_SUM') + ' ' + this.$store.getters.getSelectedCurrency, 
                    value: 'sum',
                    align: 'right', 
                    sortable: false,
                    width: "180px",
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_LABEL_SALES_DATA_CAPTION_RECORDS'), 
                    value: 'records',
                    align: 'right', 
                    sortable: false,
                    width: "90px",
                    class: 'text-no-wrap'
                },
			   	{
				   text: this.$t('lang_LABEL_SALES_DATA_CAPTION_FILE_NAME'), 
				 	value: 'fileName',
				   align: 'left', 
				   sortable: false,
				   class: 'text-no-wrap'
				}, 
				{
					text: this.$t('lang_GENERIC_CAPTION_IMPORT'), 
					value: 'importDate',
					align: 'left', 
					sortable: true,
					width: '180px',
					class: 'text-no-wrap'
				},
				{
					text: this.$t("lang_PUBLISHING_INCOME_CAPTION_CCF"), 
					value: 'conversionFactor',
					align: 'right', 
					sortable: false,
					width: '90px',
					class: 'text-no-wrap'
				},
				{
					text: '', 
					value: 'ghost',
					sortable: false,
					width: "1%",
					class: 'text-no-wrap'
				},
				{
					text: '', 
					value: 'downloadLink',
					align: 'right',
					sortable: false,
					width: "70px",
					class: 'text-no-wrap'
				},
				{
				text: '', 
				value: 'inlineEdit',
				align: 'right',
				sortable: false,
				width: "70px",
				class: 'text-no-wrap'
				}
		   ]
	    },		
		selectedImportCheckboxes: { 
			get() { return this.$store.getters.getSelectedImportDialogCheckboxes },
			set(selected) { this.$store.commit('setSelectedImportDialogCheckboxes', selected) }
		},
        withAbbreviation() {
			if (this.abbreviationsOptions && this.abbreviationsOptions.length > 0 && this.abbreviationsOptions[0].disabled === false) {
				this.$store.commit('setSalesDataDetailsAbbreviation', this.abbreviationsOptions[0].value)
				return true
			}
			return false
        },
        abbreviationsOptions() {
            let selected = this.$store.getters.getSelectedFileImport
			if (!selected || selected.length === 0) {
				return [];
			}

            let mappings = this.$store.getters.getSalesDataImportOptions.find(el => el.value == selected).mappings
			if (!mappings) {
				return []
			}

			mappings.sort((a, b) => {
				if (a.disabled === true) return 1; // Put disabled at the end
				if (b.disabled === true) return -1;
			})

			return mappings
        },
	},
	methods: {
		inlineEditing(item) {
			this.$store.commit('setSelectedSalesData', [])
			this.$store.commit('setIsAllSelectedSalesData', false)
			this.$store.commit('setSelectedSalesData', item.alvId)

			// Fill Dialog data fields
			let details = this.$store.getters.getSalesData.find(element => {
				return element.alvId === item.alvId
			})

			// make a deep copy, in case user clicks the X, so the original data is not changed
			// only after clicking the save button in the dialog
			let detailsDeepCopy = JSON.parse(JSON.stringify(details))
			
			// format numbers to ui lang setting before showing in data fields.
			if(detailsDeepCopy.conversionFactor !== null){
				detailsDeepCopy.conversionFactor = this.$i18n.n(detailsDeepCopy.conversionFactor, 'decimal8') 
			}
			// set the deep copied data in the store, so the dialog has access to it.
			this.$store.commit('setSalesDataInlineEditingDialogDetails', detailsDeepCopy)
			this.$store.commit('setShowInlineEditingDialog', true)
		}
	},
	created() {
		this.$store.commit('setSelectedSalesDataHalfYearFilter', null)
	},
}
</script>
